import {Col, DatePicker, Row, Space} from "antd";
import {useNavigate} from "react-router-dom";

import menuOptions from "../MenuOptions";
import {DefaultDisplayDateFormat, ReferralEventAction, ReferralHistory} from "data/CustomerPortalTypes";
import {useEffect, useRef, useState} from "react";
import styles from './ReferralHistory.module.css'

import GlobirdTable from 'components/Shared/GlobirdTable';
import {formatAmount, formatDisplayDate} from 'utilities/Utility';
import {GlobirdTableContainer} from 'data/GlobirdTableContainer';
import GlobirdSelector from 'components/Shared/GlobirdSelector';
import GlobirdPagination, {GlobirdPaginationControl} from 'components/Shared/GlobirdPagination';
import requestDataService from "services/RequestDataService";
import {selectCurrentAccount} from "store/userSlice";
import {useSelector} from "react-redux";

const {RangePicker} = DatePicker;

const History = () => {
    const currentAccount = useSelector(selectCurrentAccount);
    const navigate = useNavigate();

    const [referralHistoryList, setReferralHistoryList] = useState<ReferralHistory[]>([]);
    const [totalBonusPaid, setTotalBonusPaid] = useState<number>(0);
    const [filterDateRange, setFilterDateRange] = useState<[Date | null, Date | null]>([null, null]);
    const globirdPagination = useRef<GlobirdPaginationControl>(null);
    const jumpPage = (referralHistoryList: ReferralHistory[], totalCount: number) => {
        setReferralHistoryList(referralHistoryList);
    };

    const getReferralStatus = (status: ReferralEventAction) => {
        switch (status) {
            case ReferralEventAction.Quoted:
                return "Quoted";
            case ReferralEventAction.SignedUp:
                return "Signed Up";
            case ReferralEventAction.BonusPaid:
                return "Bonus Paid";
            default:
                return "";
        }
    }

    const convertGlobirdTableContainer = (referralHistories: ReferralHistory[]): GlobirdTableContainer => {
        let dataContainer = new GlobirdTableContainer();
        dataContainer.headerList.push("Date", "Who", "Action", "Bonus", "Amount");

        for (let referralHistory of referralHistories) {
            var rowData = [
                formatDisplayDate(referralHistory.date),
                `Someone in ${referralHistory.label}`,
                getReferralStatus(referralHistory.status),
                referralHistory.bonus,
                referralHistory.amount ? "$" + formatAmount(referralHistory.amount.toString()) : '',
            ];
            dataContainer.rowList.push(rowData);
        }

        return dataContainer;
    }

    const configDateRange = (dates: any) => {
        if (dates) {
            setFilterDateRange([dates[0], dates[1]]);
        } else {
            setFilterDateRange([null, null]);
        }
    }
    
    const getBonusPaidLabel = () => {
        const label = filterDateRange[0] && filterDateRange[1] ? 'Total Bonus Paid for this period:' : 'Total Bonus Paid:';
        return `${label} $${totalBonusPaid}`;
    }

    useEffect(() => {
        globirdPagination.current?.refresh();
    }, [currentAccount, filterDateRange]);

    return (
        <div className={styles['referral-history-block']}
             style={{maxWidth: '1000px', paddingBottom: '35px'}}>
            <div className='globird-menu-option'>
                <p className='globird-menu-label'>Show me:</p>
                <GlobirdSelector
                    id='linkManagementMenuSelector'
                    options={menuOptions}
                    defaultOption={menuOptions[1]}
                    onSelected={(targetMenu) => {
                        navigate(`/${targetMenu.value}`);
                    }}/>
            </div>
            <Row>
                <Col xs={24} md={16} lg={16}>
                    <div className={styles['filter-block']}>
                        <p className={styles['filter-label']}>Set date range (optional)</p>
                        <RangePicker onChange={configDateRange} format={DefaultDisplayDateFormat}/>
                    </div>
                </Col>
                <Col xs={24} md={8} lg={8} style={{alignSelf: 'end'}}>
                    <div className={styles['referral-history-bonus']}>{getBonusPaidLabel()}</div>
                </Col>
            </Row>
            <GlobirdTable dataContainer={convertGlobirdTableContainer(referralHistoryList)}></GlobirdTable>
            <GlobirdPagination
                ref={globirdPagination}
                requestDataFunc={async (offset, limit) => {
                    const referralHistoryResponse = await requestDataService.getReferralHistory(
                        currentAccount?.accountId,
                        filterDateRange[0],
                        filterDateRange[1],
                        offset,
                        limit);

                    setTotalBonusPaid(referralHistoryResponse?.data?.totalBonus || 0);

                    return {
                        data: {
                            data: referralHistoryResponse?.data?.referralHistory.data || [],
                            totalCount: referralHistoryResponse?.data?.referralHistory.totalCount || 0
                        },
                        success: true,
                        message: ''
                    }
                }}
                onJumpToPage={jumpPage}/>
        </div>
    );
}

export default History;